module.exports = __webpack_public_path__ + "static/img/f13.3adb0a0.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/f13.png
// module id = 5gtL
// module chunks = 34